import { useRef } from 'react';
import CareMapprPopup from '../../Popup/CareMapprPopup';
import './style.css';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import CareMapprButton from '../../Button/CareMapprButton';
import DashedLine from '../../Basics/DashedLine';
import { useToast } from '../../../../context';
import { CheckCircleFill } from 'react-bootstrap-icons';

import doorOpenIcon from '../../../../assets/img/button-icons/DoorOpen.svg';

interface ReconciliationSummaryPopupProps {
  open: boolean;
  onHide: () => void;
}
const ReconciliationSummaryPopup = ({
  open,
  onHide,
}: ReconciliationSummaryPopupProps) => {
  const copyRef = useRef<HTMLDivElement>(null);
  const { setToast } = useToast();
  const { patientProfile, reconciliationSummary } = useSelector(
    (state: RootState) => state.patientProfile,
  );

  const clientNumber = patientProfile.clinics?.[0]?.client_no || '';
  const patientName = `${patientProfile.first_name} ${patientProfile.middle_name || ''} ${patientProfile.last_name}`;

  const handleCopy = async () => {
    if (!copyRef.current) return;
    let text = copyRef.current.innerText.replace('Copy to clipboard', '');

    text = text.replace(/-+/g, (match) => {
      return match.length > 10 ? '--------------------' : match;
    });
    try {
      await navigator.clipboard.writeText(text);
      setToast(
        <div className="d-flex gap-1 align-items-center">
          <span>Text copied to clipboard</span>
          <CheckCircleFill />
        </div>,
      );
    } catch (err) {
      console.error('Failed to copy text:', err);
    }
  };

  return (
    <CareMapprPopup
      show={open}
      onHide={() => onHide()}
      title="Reconciliation summary"
      titleIcon={<img src={doorOpenIcon} alt="Review triggers button"></img>}
    >
      <div className="body-container" ref={copyRef}>
        <span className="subtitle">{`${patientName}${clientNumber ? ` - ${clientNumber}` : ''}`}</span>
        {reconciliationSummary?.map((section, index) => (
          <div
            className="reconciliation-section"
            key={`reconciliation-summary-pop-${index}`}
          >
            <h3 className="section-title">{`${section.title}:`}</h3>
            <p className="section-body">
              {section.body?.length > 0
                ? section.body.map((bodyText, idx) => (
                    <span key={`reconciliation-summary-pop-${index}-${idx}`}>
                      {bodyText}
                    </span>
                  ))
                : 'Nil'}
            </p>
            <DashedLine />
          </div>
        ))}
        <CareMapprButton label="Copy to clipboard" onClick={handleCopy} />
      </div>
    </CareMapprPopup>
  );
};

export default ReconciliationSummaryPopup;
